import ToogleIcon from './component'

export default ToogleIcon
